import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/_Pages/Result/schemeIndex.tsx");
